import { ref } from 'vue';
import { defineStore } from 'pinia';
import axios from 'axios';

export const useBillingStore = defineStore('billing', () => {
    const overview = ref(null);

    const actions = {
        startCheckout: () => axios.post('/api/v1/billing/checkout'),
        openPortal: () => axios.post('/api/v1/billing/portal'),
    };

    return {
        overview,
        ...actions,
    };
});

// HMR
if (import.meta.hot) {
    import.meta.hot.accept(useBillingStore.acceptHMRUpdate);
}
